import { Stack, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CustomChip } from 'src/shared/components/organisms/customChip';

type GiftStatusesProps = {
  isHandled: boolean;
  showHandled?: boolean;
  isPaid: boolean;
  showPaid?: boolean;
  chipSize: 'small' | 'medium' | undefined;
};

export const GiftStatuses = (props: GiftStatusesProps) => {
  const { isHandled, showHandled = true, isPaid, showPaid = true, chipSize } = props;
  const { t } = useTranslation(['member']);

  return (
    <Stack direction='row' spacing={1} sx={{ '& .MuiChip-filled ': { borderRadius: 1 } }}>
      {showPaid && isPaid && (
        <Tooltip describeChild title={t('gift:badges.paid')} arrow>
          <CustomChip label={t('gift:badges.paid')} color='success' size={chipSize} />
        </Tooltip>
      )}
      {showPaid && !isPaid && (
        <Tooltip describeChild title={t('gift:badges.unpaid')} arrow>
          <CustomChip label={t('gift:badges.unpaid')} color='warning' size={chipSize} />
        </Tooltip>
      )}
      {showHandled && isHandled && (
        <Tooltip describeChild title={t('gift:badges.handled')} arrow>
          <CustomChip label={t('gift:badges.handled')} color='success' size={chipSize} />
        </Tooltip>
      )}
      {showHandled && !isHandled && (
        <Tooltip describeChild title={t('gift:badges.unHandled')} arrow>
          <CustomChip label={t('gift:badges.unHandled')} color='warning' size={chipSize} />
        </Tooltip>
      )}
    </Stack>
  );
};
